module.exports = __webpack_public_path__ + "img/img_level_14.bfe28f4f.png";